import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f00cb3e")

_pushScopeId("data-v-0f00cb3e")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_2 = { class: "general_tables_class_auto" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "测试场景", -1)
const _hoisted_5 = { style: {"width":"90px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 添加分组")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 确定")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  style: {"width":"250px"}
}
const _hoisted_10 = {
  key: 2,
  style: {"width":"150px"}
}
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("em", null, "点击上传", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "el-icon-delete-solid" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 添加")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("导出数据")
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("导出表格")
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_24 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option_group = _resolveComponent("el-option-group")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_h7 = _resolveComponent("h7")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { class: "tableMinH" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, { size: "mini" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "类型" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            onChange: _ctx.type_change,
                            modelValue: _ctx.type,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.type = $event)),
                            placeholder: "请选择",
                            filterable: ""
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.type_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.type === '皮肤表格')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            style: {"margin":"20px 0"},
                            label: "皮肤测试报告链接"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                style: {"width":"300px","margin-right":"20px"},
                                modelValue: _ctx.url,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.url = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_el_button, {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.arrfim('skin'))),
                                type: "primary"
                              }, {
                                default: _withId(() => [
                                  _hoisted_1
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.type != '皮肤表格')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            style: {"margin":"20px 0"}
                          }, {
                            default: _withId(() => [
                              _createVNode("ul", _hoisted_2, [
                                _createVNode("li", null, [
                                  (_ctx.type != '通用表格-自动')
                                    ? (_openBlock(), _createBlock("span", _hoisted_3, "测试机型"))
                                    : _createCommentVNode("", true),
                                  _hoisted_4,
                                  _createVNode("span", {
                                    style: 'width:' + _ctx.coloum_width(_ctx.type) + 'px'
                                  }, "测试数据", 4),
                                  _createVNode("span", _hoisted_5, [
                                    _createVNode(_component_el_button, {
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addrow(_ctx.type))),
                                      type: "primary",
                                      size: "mini"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_6
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("span", null, [
                                    _createVNode(_component_el_button, {
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.arrfim('auto'))),
                                      type: "primary",
                                      size: "mini"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_7
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.general_tables_data_auto, (i, index) => {
                                  return (_openBlock(), _createBlock("li", {
                                    style: {"margin-bottom":"15px"},
                                    key: index
                                  }, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(i, (item, o) => {
                                      return (_openBlock(), _createBlock("div", {
                                        class: "row_div",
                                        key: o
                                      }, [
                                        (_ctx.type != '通用表格-自动')
                                          ? (_openBlock(), _createBlock("span", _hoisted_8, [
                                              _createVNode(_component_el_select, {
                                                modelValue: item.device,
                                                "onUpdate:modelValue": ($event: any) => (item.device = $event),
                                                placeholder: "请选择机型",
                                                clearable: "",
                                                filterable: ""
                                              }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (group) => {
                                                    return (_openBlock(), _createBlock(_component_el_option_group, {
                                                      key: group.label,
                                                      label: group.label
                                                    }, {
                                                      default: _withId(() => [
                                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                                          return (_openBlock(), _createBlock(_component_el_option, {
                                                            key: item.value,
                                                            label: item.label,
                                                            value: item.value
                                                          }, null, 8, ["label", "value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["label"]))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode("span", null, [
                                          _createVNode(_component_el_input, {
                                            modelValue: item.scene,
                                            "onUpdate:modelValue": ($event: any) => (item.scene = $event),
                                            size: "mini"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        (_ctx.type == '通用表格-自动')
                                          ? (_openBlock(), _createBlock("span", _hoisted_9, [
                                              _createVNode(_component_el_input, {
                                                modelValue: item.url,
                                                "onUpdate:modelValue": ($event: any) => (item.url = $event),
                                                size: "mini"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.type == '通用表格-人工')
                                          ? (_openBlock(), _createBlock("span", _hoisted_10, [
                                              _createVNode(_component_el_upload, {
                                                class: "upload-demo uploadBox",
                                                action: "http://127.0.0.1:8080/api/v1/performance/perfdog_arrange_by_xlsx/",
                                                limit: 1,
                                                "data-index": index,
                                                "http-request": 
                          (file, fileList) =>
                            _ctx.ploadImage(file, fileList, index, o)
                        ,
                                                "on-remove": 
                          (file, fileList) =>
                            _ctx.ploadImage(file, fileList, index, o)
                        ,
                                                style: {"color":"#c0c4cc","border":"1px solid #dcdfe6","border-radius":"4px","height":"30px","width":"100%","text-align":"center","position":"relative"},
                                                ref: 'upload'
                                              }, {
                                                default: _withId(() => [
                                                  _hoisted_11,
                                                  _hoisted_12
                                                ]),
                                                _: 2
                                              }, 1032, ["data-index", "http-request", "on-remove"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode("span", null, [
                                          _createVNode(_component_el_button, {
                                            onClick: ($event: any) => (_ctx.removeBtn(i, o, index)),
                                            size: "mini",
                                            type: "danger"
                                          }, {
                                            default: _withId(() => [
                                              _hoisted_13
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ])
                                      ]))
                                    }), 128)),
                                    _createVNode(_component_el_button, {
                                      onClick: ($event: any) => (_ctx.addrow_auto(i)),
                                      type: "primary",
                                      size: "mini"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_14
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.type === '通用表格-人工')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: "包括label1数据"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_checkbox, {
                                modelValue: _ctx.is_label1,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.is_label1 = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.type === '皮肤表格')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            style: {"margin":"20px 0"},
                            label: "指标"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.indicator_value,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.indicator_value = $event)),
                                placeholder: "请选择",
                                multiple: "",
                                "collapse-tags": "",
                                "collapse-tags-tooltip": ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_row, {
                                    justify: "space-around",
                                    type: "flex"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        class: "select-tag-class",
                                        style: {"width":"48%"},
                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleSelectAll2('close')))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_15
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        style: {"width":"48%"},
                                        class: "select-tag-class",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSelectAll2('open')))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_16
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.index_key, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.name,
                                      label: item.name,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 4,
                            style: {"margin":"20px 0"},
                            label: "指标"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.auto_value,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.auto_value = $event)),
                                placeholder: "请选择",
                                multiple: "",
                                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.autoChange())),
                                "collapse-tags": "",
                                "collapse-tags-tooltip": ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_row, {
                                    justify: "space-around",
                                    type: "flex"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        class: "select-tag-class",
                                        style: {"width":"48%"},
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSelectAll3('close')))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_17
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_tag, {
                                        type: "primary",
                                        style: {"width":"48%"},
                                        class: "select-tag-class",
                                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSelectAll3('open')))
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_18
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metrics, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.name,
                                      label: item.name,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_el_button, {
                                style: {"margin-left":"10px"},
                                type: "primary",
                                onClick: _ctx.downloadCsv
                              }, {
                                default: _withId(() => [
                                  _hoisted_19
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })),
                      (_ctx.type == '皮肤表格')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 5,
                            style: {"margin":"20px 0"},
                            label: "皮肤名称"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                onChange: _ctx.skin_change,
                                modelValue: _ctx.skin_name,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.skin_name = $event)),
                                placeholder: "请选择",
                                filterable: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.name_list, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item,
                                      label: item,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onChange", "modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_20, [
                    _createVNode(_component_el_button, {
                      size: "mini",
                      type: "primary",
                      onClick: _ctx.exportTable
                    }, {
                      default: _withId(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  (_ctx.type === '皮肤表格')
                    ? (_openBlock(), _createBlock("div", _hoisted_22, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.indicator_value, (v, index) => {
                          return (_openBlock(), _createBlock("div", { key: v }, [
                            _createVNode(_component_h7, { style: {"display":"flex","align-items":"center"} }, {
                              default: _withId(() => [
                                _hoisted_23,
                                _createVNode("span", null, _toDisplayString(_ctx.index_key.filter((m) => m.value == v)[0].name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_table, {
                              id: `skin-table${index}`,
                              "span-method": _ctx.spanMethod,
                              size: "mini",
                              "header-cell-style": {
                  background: '#5D99D5',

                  color: '#fff',
                },
                              border: "",
                              data: _ctx.skinData
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, { label: "皮肤" }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row.name), 1)
                                  ]),
                                  _: 1
                                }),
                                (_ctx.url.indexOf('test_report_skin_inside') == -1)
                                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                                      key: 0,
                                      label: "动作"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(_ctx.getAction(scope.row.data, _ctx.skinData_head)), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_table_column, { label: "id" }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(_ctx.getId(scope.row.data, _ctx.skinData_head)), 1)
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skinData_head, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_table_column, {
                                    label: item,
                                    key: index
                                  }, {
                                    default: _withId((scope) => [
                                      _createTextVNode(_toDisplayString(_ctx.getData(scope.row.data, item, v)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["id", "span-method", "data"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.type !== '皮肤表格')
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        _createVNode(_component_el_table, {
                          id: "detailTable",
                          "header-cell-style": {
                background: '#5D99D5',

                color: '#fff',
              },
                          size: "mini",
                          border: "",
                          "span-method": _ctx.mergeCells2,
                          data: _ctx.autoTableData
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              label: "机型",
                              prop: "name"
                            }),
                            _createVNode(_component_el_table_column, { label: "场景" }, {
                              default: _withId((scope) => [
                                _createTextVNode(_toDisplayString(scope.row.data.scene
                      ? scope.row.data.scene
                      : scope.row.data.inning), 1)
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.auto_list, (item) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: item,
                                label: item.name
                              }, {
                                default: _withId((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.data[item.value]), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128)),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.auto_change_list, (item) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: item,
                                label: item.name
                              }, {
                                default: _withId((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.data[item.value]), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128)),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_list, (item) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: item,
                                label: item.name
                              }, {
                                default: _withId((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.data[item.value]), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["span-method", "data"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})